export default "__VITE_ASSET__CjZZdr2e__"